import CartAnalyzeContainer from './CartAnalyzeContainer';
export default CartAnalyzeContainer;
